(function () {
  function inchesToCm(value) {
    if (!value || value === '—') return '—';

    const parts = String(value)
      .split('-')
      .map((part) => part.trim())
      .filter(Boolean);

    if (parts.length > 1) {
      return parts
        .map((part) => {
          const num = parseFloat(part);
          if (Number.isNaN(num)) return part;
          return (num * 2.54).toFixed(1).replace(/\.0$/, '');
        })
        .join('-');
    }

    const num = parseFloat(parts[0]);
    if (Number.isNaN(num)) return value;
    return (num * 2.54).toFixed(1).replace(/\.0$/, '');
  }

  function setUnit(modal, unit) {
    const isCm = unit === 'cm';
    const toggle = modal.querySelector('[data-size-chart-unit-toggle]');
    const unitLabels = modal.querySelectorAll('[data-size-chart-unit-label]');
    const cells = modal.querySelectorAll('[data-measurement-value]');

    if (toggle) {
      toggle.setAttribute('aria-checked', isCm ? 'true' : 'false');
    }

    unitLabels.forEach((label) => {
      const labelUnit = label.dataset.sizeChartUnitLabel;
      label.classList.toggle('is-active', labelUnit === unit);
    });

    cells.forEach((cell) => {
      const inchValue = cell.dataset.measurementValue;
      cell.textContent = isCm ? inchesToCm(inchValue) : inchValue;
    });

    modal.dataset.sizeChartUnit = unit;
  }

  function highlightSizeColumn(modal, colIndex) {
    modal.querySelectorAll('[data-size-col]').forEach((el) => {
      const match = el.dataset.sizeCol === String(colIndex);
      el.classList.toggle('is-selected-col', match);
    });
  }

  function getVariantSelects() {
    return document.querySelector('variant-selects');
  }

  function getSelectedOptionValueId() {
    const variantSelects = getVariantSelects();
    if (variantSelects) {
      const checked = variantSelects.querySelector('[data-option-value-id]:checked');
      if (checked) return checked.dataset.optionValueId;
    }

    const pseudoForm = document.querySelector('[data-pseudo-form]');
    if (pseudoForm) {
      const checked = pseudoForm.querySelector('[data-option-value-id]:checked');
      if (checked) return checked.dataset.optionValueId;
    }

    const qvForm = document.querySelector('[data-qv-form]');
    if (qvForm) {
      const activeOption = qvForm.querySelector('.qv-option.is-active');
      if (activeOption) return activeOption.dataset.value;
    }

    return null;
  }

  function syncSizeToMainForm(radio) {
    if (!radio) return false;

    const optionValueId = radio.dataset.optionValueId;
    const sizeValue = radio.dataset.sizeValue;
    let synced = false;

    const variantSelects = getVariantSelects();
    if (variantSelects && optionValueId) {
      const mainInput = variantSelects.querySelector(
        `[data-option-value-id="${optionValueId}"]`
      );
      if (mainInput && !mainInput.disabled) {
        mainInput.click();
        synced = true;
      }
    }

    const pseudoForm = document.querySelector('[data-pseudo-form]');
    if (pseudoForm && optionValueId) {
      const pseudoInput = pseudoForm.querySelector(
        `[data-option-value-id="${optionValueId}"]`
      );
      if (pseudoInput && !pseudoInput.disabled) {
        pseudoInput.click();
        synced = true;
      }
    }

    const qvForm = document.querySelector('[data-qv-form]');
    if (qvForm && sizeValue) {
      const qvOption = qvForm.querySelector(
        `.qv-option[data-value="${CSS.escape(sizeValue)}"]`
      );
      if (qvOption && !qvOption.disabled && !qvOption.classList.contains('is-unavailable')) {
        qvOption.click();
        synced = true;
      }
    }

    return synced;
  }

  function syncRadioToMainForm(modal) {
    const optionValueId = getSelectedOptionValueId();
    let radio = null;

    if (optionValueId) {
      radio =
        modal.querySelector(`input[data-option-value-id="${optionValueId}"]`) ||
        modal.querySelector(`input[data-size-value="${CSS.escape(optionValueId)}"]`);
    }

    if (!radio) {
      radio = modal.querySelector('input[data-size-col]');
    }

    if (!radio) return;

    radio.checked = true;
    highlightSizeColumn(modal, radio.dataset.sizeCol);
  }

  function getMainFormButtons() {
    const revampForm = document.querySelector('.revamp-product-form');
    if (revampForm) {
      return {
        addToCart: revampForm.querySelector('.product-form__submit'),
        buyNow: revampForm.querySelector('#gokwik-buy-now'),
      };
    }

    const qvForm = document.querySelector('[data-qv-form]');
    if (qvForm) {
      return {
        addToCart: qvForm.querySelector('.qv-atc'),
        buyNow: qvForm.querySelector('#gokwik-buy-now'),
      };
    }

    const productForm = document.querySelector('.product-form');
    if (productForm) {
      return {
        addToCart: productForm.querySelector('.product-form__submit'),
        buyNow: productForm.querySelector('#gokwik-buy-now'),
      };
    }

    return { addToCart: null, buyNow: null };
  }

  function triggerMainFormAction(action) {
    const { addToCart, buyNow } = getMainFormButtons();

    if (action === 'addToCart') {
      if (addToCart && !addToCart.disabled) {
        addToCart.click();
        return true;
      }
      return false;
    }

    if (action === 'buyNow') {
      if (buyNow && !buyNow.disabled && !buyNow.classList.contains('disabled')) {
        buyNow.click();
        return true;
      }
      if (typeof window.onBuyNowClick === 'function') {
        window.onBuyNowClick(buyNow);
        return true;
      }
      return false;
    }

    return false;
  }

  function openModal(modal) {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    setUnit(modal, modal.dataset.sizeChartUnit || 'in');
    syncRadioToMainForm(modal);
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }

  function closeAllModals() {
    document.querySelectorAll('.size-chart-overlay.is-open').forEach(closeModal);
  }

  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('.pdp-size-guide-trigger');
    if (openBtn) {
      const modalId = openBtn.getAttribute('aria-controls');
      const modal = modalId ? document.getElementById(modalId) : null;
      if (modal) openModal(modal);
      return;
    }

    const closeBtn = event.target.closest('.size-chart-close');
    if (closeBtn) {
      closeModal(closeBtn.closest('.size-chart-overlay'));
      return;
    }

    if (event.target.classList.contains('size-chart-overlay')) {
      closeModal(event.target);
      return;
    }

    const unitToggle = event.target.closest('[data-size-chart-unit-toggle]');
    if (unitToggle) {
      const modal = unitToggle.closest('.size-chart-overlay');
      if (modal) {
        const nextUnit = modal.dataset.sizeChartUnit === 'cm' ? 'in' : 'cm';
        setUnit(modal, nextUnit);
      }
      return;
    }

    const buyNowBtn = event.target.closest('[data-size-chart-buy-now]');
    if (buyNowBtn) {
      const modal = buyNowBtn.closest('.size-chart-overlay');
      const checkedRadio = modal?.querySelector('.size-chart-size-radio input:checked');
      if (checkedRadio) syncSizeToMainForm(checkedRadio);
      closeModal(modal);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          triggerMainFormAction('buyNow');
        });
      });
      return;
    }

    const addToCartBtn = event.target.closest('[data-size-chart-add-to-cart]');
    if (addToCartBtn) {
      const modal = addToCartBtn.closest('.size-chart-overlay');
      const checkedRadio = modal?.querySelector('.size-chart-size-radio input:checked');
      if (checkedRadio) syncSizeToMainForm(checkedRadio);
      closeModal(modal);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          triggerMainFormAction('addToCart');
        });
      });
    }
  });

  document.addEventListener('change', (event) => {
    const radio = event.target.closest('.size-chart-size-radio input[type="radio"]');
    if (!radio) return;

    syncSizeToMainForm(radio);
    highlightSizeColumn(radio.closest('.size-chart-overlay'), radio.dataset.sizeCol);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeAllModals();
  });
})();
